/// <reference path="" />

(function (jQuery, undefined) {
    var sm = (window.sm = window.sm || {});
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === 'undefined') {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === 'undefined') {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Academic Interests View Model
    // Holds the various academic values used for Inquiry and Applications
    /**************************************/
    function AcademicInterestsViewModel() {
        // Self-Identification
        var self = this;

        self.validationEnabled = ko.observable(false);
        self.isValidationEnabled = function () {
            return self.validationEnabled();
        };
        self.ShowDialog = function (elementId) {
            jQuery(elementId).addClass('inYourFace');
            jQuery(elementId).removeClass('hidden').addClass('visible');
        }
        self.HideDialog = function (elementId) {
            jQuery(elementId).removeClass('inYourFace');
            jQuery(elementId).removeClass('visible').addClass('hidden');
        }
        self.ShowHideHelp = function (elementId) {
            if (jQuery(elementId).hasClass('hidden')) {
                jQuery(elementId).removeClass('hidden').addClass('visible');
            }
            else {
                jQuery(elementId).removeClass('visible').addClass('hidden');
            }
        }

        /***  PROPERTIES ***/
        this.ExpectedStartPeriodID = ko.validatedObservable();
        this.ExpectedEntrancePeriodRequired = ko.observable(false);
        this.DeliveryMethodID = ko.validatedObservable();
        this.CampusID = ko.validatedObservable();
        this.ApplicationGoalID = ko.validatedObservable();
        this.AdmissionsProgramID = ko.validatedObservable();
        this.AcademicLevelID = ko.validatedObservable();
        this.EarliestStartDate = ko.validatedObservable();
        this.CategoryID = ko.validatedObservable();
        this.InitialEnrollmentStatusID = ko.validatedObservable();
        this.ExpectedLoadID = ko.validatedObservable();
        this.AttendanceTypeID = ko.validatedObservable();
        this.AttendanceReasonID = ko.validatedObservable();
        this.AdmissionsProgramDescription = ko.validatedObservable();
        this.APOIDescription = ko.observable();

        this.LevelOfStudyID = ko.validatedObservable();
        this.LevelOfStudyEnabled = ko.computed(function () { return false; });
        this.LevelOfStudyShow = ko.observable(false);

        this.AdmissionsProgramOfferingItemID = ko.validatedObservable();
        this.AdmissionsProgramOfferingItemEnabled = ko.observable(false);
        /***  PROPERTIES ***/

        /***  LIST DATA PROPERTIES ***/
        this.AcademicPeriods = ko.observableArray();

        this.AdmissionsCategories = ko.observableArray();
        this.InitialEnrollmentStatuses = ko.observableArray();
        this.ExpectedEnrollmentLoads = ko.observableArray();
        this.AttendanceTypes = ko.observableArray();
        this.AttendanceReasons = ko.observableArray();

        this.AdmissionsAcademicLevels = ko.observableArray();
        this.Goals = ko.observableArray();
        this.AdmissionsPrograms = ko.observableArray();
        this.DeliveryMethods = ko.observableArray();
        this.Campuses = ko.observableArray();
        this.AdmissionsOfferingItems = ko.observableArray();
        this.LevelsOfStudy = ko.observableArray();

        this.UpdateTemplateProperties = {
            SummaryAcademicTemplate: ko.observable(''),
            ProgrammeChoiceTemplate: ko.observable(''),
            ShowAPDescriptionOnPortal: ko.observable(false),
            ShowAPOIDescriptionOnPortal: ko.observable(false),

            AcademicSectionHeaderText: ko.observable(''),
            AcademicSectionHeaderTextVisible: ko.observable(false),
            AutoSelectSingleFields: ko.observable(false),

            AcademicStartPeriodLabel: ko.observable('AcademicStartPeriod'),
            AcademicLevelLabel: ko.observable('AcademicLevel'),
            ApplicationGoalLabel: ko.observable('ApplicationGoal'),
            AdmissionsProgramLabel: ko.observable('AdmissionsProgram'),
            DeliveryMethodLabel: ko.observable('DeliveryMethod'),
            ProgramRouteLabel: ko.observable('AdmissionsProgramOfferingItem'),
            CampusLabel: ko.observable('Campus'),
            InitialEnrollmentLabel: ko.observable('InitialEnrollmentStatus'),
            ExpectedEnrollmentLabel: ko.observable('ExpectedEnrollmentLoad'),
            AttendanceTypeLabel: ko.observable('AttendanceType'),
            AttendanceReasonLabel: ko.observable('AttendanceReason'),

            AcademicStartPeriodRequired: ko.observable(true),
            AcademicLevelRequired: ko.observable(true),
            ApplicationGoalRequired: ko.observable(true),
            AdmissionsProgramRequired: ko.observable(true),
            DeliveryMethodRequired: ko.observable(true),
            ProgramRouteRequired: ko.observable(true),
            CampusRequired: ko.observable(true),
            InitialEnrollmentRequired: ko.observable(false),
            ExpectedEnrollmentRequired: ko.observable(false),
            AttendanceTypeRequired: ko.observable(false),
            AttendanceReasonRequired: ko.observable(false),

            AcademicStartPeriodVisible: ko.observable(true),
            AcademicLevelVisible: ko.observable(true),
            ApplicationGoalVisible: ko.observable(true),
            AdmissionsProgramVisible: ko.observable(true),
            DeliveryMethodVisible: ko.observable(true),
            ProgramRouteVisible: ko.observable(true),
            CampusVisible: ko.observable(true),
            InitialEnrollmentVisible: ko.observable(true),
            ExpectedEnrollmentVisible: ko.observable(true),
            AttendanceTypeVisible: ko.observable(true),
            AttendanceReasonVisible: ko.observable(true),

            AcademicStartPeriodHelp: ko.observable(''),
            AcademicLevelHelp: ko.observable(''),
            ApplicationGoalHelp: ko.observable(''),
            AdmissionsProgramHelp: ko.observable(''),
            DeliveryMethodHelp: ko.observable(''),
            ProgramRouteHelp: ko.observable(''),
            CampusHelp: ko.observable(''),
            InitialEnrollmentHelp: ko.observable(''),
            ExpectedEnrollmentHelp: ko.observable(''),
            AttendanceTypeHelp: ko.observable(''),
            AttendanceReasonHelp: ko.observable(''),

            ResetFieldsVisible: ko.observable(true),
        }
        /***  LIST DATA PROPERTIES ***/

        /***  MATRIX DATA PROPERTIES ***/
        /***  MATRIX DATA PROPERTIES ***/

        /** SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable('AcademicContainer');
        this.Touched = ko.observable(false);
        this.DataLoadErrorCount = ko.observable();
        this.FirstLoad = ko.observable(true);
        /*** SECTION PROPERTIES ***/

        sm.portal.vm.custom.setCustomLocalizeKey(self.UpdateTemplateProperties);

        /*** COMPUTED LIST PROPERTIES ***/
        this.LevelOfStudiesOn = ko.computed(function () {
            return self.LevelOfStudyEnabled() && self.LevelOfStudyShow();
        }, this);

        this.IsLevelOfStudySelected = ko.computed(function () {
            if (!sm.portal.utility.isNullOrEmpty(this.LevelOfStudyID()) && self.LevelOfStudyEnabled()) {
                return true;
            }
            return false;
        }, this);

        this.IsApplicantChoosesProgramCurriculumSelected = ko.computed(function () {
            if (!sm.portal.utility.isNullOrEmpty(this.AdmissionsProgramOfferingItemID()) && self.AdmissionsProgramOfferingItemEnabled()) {
                return true;
            }
            return false;
        }, this);

        /*** COMPUTED LIST PROPERTIES ***/

        /***  COMPUTED PROPERTIES ***/
        this.AnythingPopulated = ko.computed(function () {
            return true; // required section
        }, this);
        /***  COMPUTED PROPERTIES ***/

        sm.portal.vm.custom.callCustomization('UpdateAcademicInterestsProperties', self);

        /*** FILTER FUNCTION ***/

        function SortBySequence(a, b) {

            if (a.Sequence() > b.Sequence()) {
                return 1;
            }
            else if (a.Sequence() == b.Sequence()) {
                return 0;
            }
            else {
                return -1;
            }
        }
        /*** FILTER FUNCTION ***/

        /*** SECTION METHODS ***/
        this.LoadModel = function (container, extractATOMode) {
            var customData = {
                self: self,
                container: container,
                extractATOMode: extractATOMode
            }
            var loadModelUpdated = sm.portal.vm.custom.callCustomization('UpdateLoadPropertiesForAcademic', customData);
            if (sm.portal.utility.isNullOrEmpty(loadModelUpdated)) {
                // update application section configurations
                if (container && container.Payload && container.Payload.Config) {
                    // Update values for Section only: Section Show/Hide, Section Name and Appearance Order
                    viewModel.SetSectionsConfigData("Academic", container.Payload.Config);

                    // Update new config toggle: AutoSelectSingleFields
                    this.UpdateTemplateProperties.AutoSelectSingleFields(container.Payload.Config.AutoSelectSingleFields);

                    // Set the Basic List Data properties
                    this.InitialEnrollmentStatuses = smapi.access.loadListItemModels(container.Payload.ListData.InitialEnrollmentStatus, this.InitialEnrollmentStatuses, true);
                    if (this.UpdateTemplateProperties.AutoSelectSingleFields() && container.Payload.ListData.InitialEnrollmentStatus.length === 1) { this.InitialEnrollmentStatusID(container.Payload.ListData.InitialEnrollmentStatus[0].ID); }

                    this.ExpectedEnrollmentLoads = smapi.access.loadListItemModels(container.Payload.ListData.ExpectedEnrollmentLoads, this.ExpectedEnrollmentLoads, true);
                    if (this.UpdateTemplateProperties.AutoSelectSingleFields() && container.Payload.ListData.ExpectedEnrollmentLoads.length === 1) { this.ExpectedLoadID(container.Payload.ListData.ExpectedEnrollmentLoads[0].ID); }

                    this.AttendanceTypes = smapi.access.loadListItemModels(container.Payload.ListData.AttendanceTypes, this.AttendanceTypes, true);
                    if (this.UpdateTemplateProperties.AutoSelectSingleFields() && container.Payload.ListData.AttendanceTypes.length === 1) { this.AttendanceTypeID(container.Payload.ListData.AttendanceTypes[0].ID); }

                    this.AttendanceReasons = smapi.access.loadListItemModels(container.Payload.ListData.AttendanceReasons, this.AttendanceReasons, true);
                    if (this.UpdateTemplateProperties.AutoSelectSingleFields() && container.Payload.ListData.AttendanceReasons.length === 1) { this.AttendanceReasonID(container.Payload.ListData.AttendanceReasons[0].ID); }

                    self.IsLevelOfStudyActivated = container.Payload.IsLevelOfStudyActivated;
                    this.LevelOfStudyEnabled = ko.computed(function () { return self.IsLevelOfStudyActivated && self.LevelsOfStudy().length > 0; });

                    this.ExpectedEntrancePeriodRequired(container.Payload.IsExpectedEntrancePeriodRequired);
                    this.AdmissionsProgramOfferingItemEnabled(container.Payload.IsApplicantChoosesProgramCurriculumActivated);

                    // Update: AcademicSectionHeaderText
                    if (container.Payload.Config.AcademicSectionHeaderText != '') {
                        var headerTextBytes = atob(container.Payload.Config.AcademicSectionHeaderText);
                        var customHeaderText = new TextDecoder("utf-8").decode(new Uint8Array([...headerTextBytes].map(char => char.charCodeAt(0))));

                        let myElement = new DOMParser().parseFromString(customHeaderText, 'text/html');
                        myElement.querySelectorAll('ul li').forEach(li => li.style.listStyleType = 'disc');
                        myElement.querySelectorAll('ul').forEach(ul => ul.style.paddingLeft = '40px');

                        var p_tag = Array.from(myElement.querySelectorAll('body')).map((p) => {
                            this.UpdateTemplateProperties.AcademicSectionHeaderTextVisible(p.innerText.trim() != '');
                            return p.innerHTML;
                        });

                        this.UpdateTemplateProperties.AcademicSectionHeaderText(p_tag);
                    }

                    // Update: AcademicStartPeriod Label, Required, Visible and Help
                    if (container.Payload.Config.AcademicStartPeriodLabel != '') {
                        this.UpdateTemplateProperties.AcademicStartPeriodLabel(container.Payload.Config.AcademicStartPeriodLabel);
                    }
                    this.UpdateTemplateProperties.AcademicStartPeriodRequired(container.Payload.Config.AcademicStartPeriodRequired);
                    this.UpdateTemplateProperties.AcademicStartPeriodVisible(container.Payload.Config.AcademicStartPeriodVisible);
                    this.UpdateTemplateProperties.AcademicStartPeriodHelp(container.Payload.Config.AcademicStartPeriodHelp);

                    // Update: AcademicLevel Label, Required, Visible and Help
                    if (container.Payload.Config.AcademicLevelLabel != '') {
                        this.UpdateTemplateProperties.AcademicLevelLabel(container.Payload.Config.AcademicLevelLabel);
                    }
                    this.UpdateTemplateProperties.AcademicLevelRequired(container.Payload.Config.AcademicLevelRequired);
                    this.UpdateTemplateProperties.AcademicLevelVisible(container.Payload.Config.AcademicLevelVisible);
                    this.UpdateTemplateProperties.AcademicLevelHelp(container.Payload.Config.AcademicLevelHelp);

                    // Update: ApplicationGoal Label, Required, Visible and Help
                    if (container.Payload.Config.ApplicationGoalLabel != '') {
                        this.UpdateTemplateProperties.ApplicationGoalLabel(container.Payload.Config.ApplicationGoalLabel);
                    }
                    this.UpdateTemplateProperties.ApplicationGoalRequired(container.Payload.Config.ApplicationGoalRequired);
                    this.UpdateTemplateProperties.ApplicationGoalVisible(container.Payload.Config.ApplicationGoalVisible);
                    this.UpdateTemplateProperties.ApplicationGoalHelp(container.Payload.Config.ApplicationGoalHelp);

                    // Update: AdmissionsProgram Label, Required, Visible and Help
                    if (container.Payload.Config.AdmissionsProgramLabel != '') {
                        this.UpdateTemplateProperties.AdmissionsProgramLabel(container.Payload.Config.AdmissionsProgramLabel);
                    }
                    this.UpdateTemplateProperties.AdmissionsProgramRequired(container.Payload.Config.AdmissionsProgramRequired);
                    this.UpdateTemplateProperties.AdmissionsProgramVisible(container.Payload.Config.AdmissionsProgramVisible);
                    this.UpdateTemplateProperties.AdmissionsProgramHelp(container.Payload.Config.AdmissionsProgramHelp);

                    // Update: DeliveryMethod Label, Required, Visible and Help
                    if (container.Payload.Config.DeliveryMethodLabel != '') {
                        this.UpdateTemplateProperties.DeliveryMethodLabel(container.Payload.Config.DeliveryMethodLabel);
                    }
                    this.UpdateTemplateProperties.DeliveryMethodRequired(container.Payload.Config.DeliveryMethodRequired);
                    this.UpdateTemplateProperties.DeliveryMethodVisible(container.Payload.Config.DeliveryMethodVisible);
                    this.UpdateTemplateProperties.DeliveryMethodHelp(container.Payload.Config.DeliveryMethodHelp);

                    // Update: ProgramRoute Label, Required, Visible and Help
                    if (container.Payload.Config.ProgramRouteLabel != '') {
                        this.UpdateTemplateProperties.ProgramRouteLabel(container.Payload.Config.ProgramRouteLabel);
                    }
                    this.UpdateTemplateProperties.ProgramRouteRequired(container.Payload.Config.ProgramRouteRequired);
                    this.UpdateTemplateProperties.ProgramRouteVisible(container.Payload.Config.ProgramRouteVisible);
                    this.UpdateTemplateProperties.ProgramRouteHelp(container.Payload.Config.ProgramRouteHelp);

                    // Update: Campus Label, Required, Visible and Help
                    if (container.Payload.Config.CampusLabel != '') {
                        this.UpdateTemplateProperties.CampusLabel(container.Payload.Config.CampusLabel);
                    }
                    this.UpdateTemplateProperties.CampusRequired(container.Payload.Config.CampusRequired);
                    this.UpdateTemplateProperties.CampusVisible(container.Payload.Config.CampusVisible);
                    this.UpdateTemplateProperties.CampusHelp(container.Payload.Config.CampusHelp);

                    // Update: InitialEnrollment Label, Required, Visible and Help. Hidden if: OFF in the Configuration Settings and only 1 option on the dropdown 
                    if (container.Payload.Config.InitialEnrollmentLabel != '') {
                        this.UpdateTemplateProperties.InitialEnrollmentLabel(container.Payload.Config.InitialEnrollmentLabel);
                    }
                    this.UpdateTemplateProperties.InitialEnrollmentRequired(container.Payload.Config.InitialEnrollmentRequired);
                    this.UpdateTemplateProperties.InitialEnrollmentVisible(!container.Payload.Config.InitialEnrollmentRequired ? container.Payload.Config.InitialEnrollmentVisible : (container.Payload.Config.InitialEnrollmentVisible ? true : (this.InitialEnrollmentStatuses().length > 1 ? true : !this.UpdateTemplateProperties.AutoSelectSingleFields())));
                    this.UpdateTemplateProperties.InitialEnrollmentHelp(container.Payload.Config.InitialEnrollmentHelp);

                    // Update: ExpectedEnrollment Label, Required, Visible and Help
                    if (container.Payload.Config.ExpectedEnrollmentLabel != '') {
                        this.UpdateTemplateProperties.ExpectedEnrollmentLabel(container.Payload.Config.ExpectedEnrollmentLabel);
                    }
                    this.UpdateTemplateProperties.ExpectedEnrollmentRequired(container.Payload.Config.ExpectedEnrollmentRequired);
                    this.UpdateTemplateProperties.ExpectedEnrollmentVisible(!container.Payload.Config.ExpectedEnrollmentRequired ? container.Payload.Config.ExpectedEnrollmentVisible : (container.Payload.Config.ExpectedEnrollmentVisible ? true : (this.ExpectedEnrollmentLoads().length > 1 ? true : !this.UpdateTemplateProperties.AutoSelectSingleFields())));
                    this.UpdateTemplateProperties.ExpectedEnrollmentHelp(container.Payload.Config.ExpectedEnrollmentHelp);

                    // Update: AttendanceType Label, Required, Visible and Help
                    if (container.Payload.Config.AttendanceTypeLabel != '') {
                        this.UpdateTemplateProperties.AttendanceTypeLabel(container.Payload.Config.AttendanceTypeLabel);
                    }
                    this.UpdateTemplateProperties.AttendanceTypeRequired(container.Payload.Config.AttendanceTypeRequired);
                    this.UpdateTemplateProperties.AttendanceTypeVisible(!container.Payload.Config.AttendanceTypeRequired ? container.Payload.Config.AttendanceTypeVisible : (container.Payload.Config.AttendanceTypeVisible ? true : (this.AttendanceTypes().length > 1 ? true : !this.UpdateTemplateProperties.AutoSelectSingleFields())));
                    this.UpdateTemplateProperties.AttendanceTypeHelp(container.Payload.Config.AttendanceTypeHelp);

                    // Update: AttendanceReason Label, Required, Visible and Help
                    if (container.Payload.Config.AttendanceReasonLabel != '') {
                        this.UpdateTemplateProperties.AttendanceReasonLabel(container.Payload.Config.AttendanceReasonLabel);
                    }
                    this.UpdateTemplateProperties.AttendanceReasonRequired(container.Payload.Config.AttendanceReasonRequired);
                    this.UpdateTemplateProperties.AttendanceReasonVisible(!container.Payload.Config.AttendanceReasonRequired ? container.Payload.Config.AttendanceReasonVisible : (container.Payload.Config.AttendanceReasonVisible ? true : (this.AttendanceReasons().length > 1 ? true : !this.UpdateTemplateProperties.AutoSelectSingleFields())));
                    this.UpdateTemplateProperties.AttendanceReasonHelp(container.Payload.Config.AttendanceReasonHelp);
                }
                // Transfer the Admissions Academic Levels to the other View Models (College)
                //viewModel.LoadChildData('College', 'AdmissionsAcademicLevels', this.AdmissionsAcademicLevels());

                if (container.Payload.Academic != null) {
                    // TODO: Load Model with Existing Data
                    var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
                    if (container.Payload.Academic.EarliestStartDate) {
                        this.EarliestStartDate(
                            moment(container.Payload.Academic.EarliestStartDate, 'YYYY-MM-DDTHH:mm:ss').format(
                                dateFormat
                            )
                        );
                    } else {
                        this.EarliestStartDate(container.Payload.Academic.EarliestStartDate);
                    }

                    if (container.Payload.Academic.ExpectedStartPeriodID != null) {
                        this.ExpectedStartPeriodID(container.Payload.Academic.ExpectedStartPeriodID);
                    }
                    if (container.Payload.Academic.AcademicLevelID != null) {
                        this.AcademicLevelID(container.Payload.Academic.AcademicLevelID);
                    }
                    if (container.Payload.Academic.ApplicationGoalID != null) {
                        this.ApplicationGoalID(container.Payload.Academic.ApplicationGoalID);
                    }
                    if (container.Payload.Academic.AdmissionsProgramID != null) {
                        this.AdmissionsProgramID(container.Payload.Academic.AdmissionsProgramID);
                    }
                    if (container.Payload.Academic.DeliveryMethodID != null) {
                        this.DeliveryMethodID(container.Payload.Academic.DeliveryMethodID);
                    }
                    if (container.Payload.Academic.AdmissionsProgramOfferingItemID != null) {
                        this.AdmissionsProgramOfferingItemID(container.Payload.Academic.AdmissionsProgramOfferingItemID);
                    }
                    if (container.Payload.Academic.CampusID != null) {
                        this.CampusID(container.Payload.Academic.CampusID);
                    }
                    if (container.Payload.Academic.InitialEnrollmentStatusID != null) {
                        this.InitialEnrollmentStatusID(container.Payload.Academic.InitialEnrollmentStatusID);
                    }
                    if (container.Payload.Academic.ExpectedLoadID != null) {
                        this.ExpectedLoadID(container.Payload.Academic.ExpectedLoadID);
                    }
                    if (container.Payload.Academic.AttendanceTypeID != null) {
                        this.AttendanceTypeID(container.Payload.Academic.AttendanceTypeID);
                    }
                    if (container.Payload.Academic.AttendanceReasonID != null) {
                        this.AttendanceReasonID(container.Payload.Academic.AttendanceReasonID);
                    }

                    this.CategoryID(container.Payload.Academic.CategoryID);
                    this.LevelOfStudyID(container.Payload.Academic.LevelOfStudyID);
                }

                this.AcademicLevelID.subscribe(function (newValue) {
                    if (viewModel.GetSectionModel('TestScore')) {
                        viewModel.GetSectionModel('TestScore').DataList([]);
                    }
                    if (!sm.portal.utility.isNullOrEmpty(newValue)) {
                        ChooseDefaultLevelOfStudy(self);
                    }

                });

                this.DataLoading(false);
                this.DataLoaded(true);
            }

            if (smapi.constant.applicationDebugFlag) { console.log('[AcademicVM] Data Loaded'); }
        };

        sm.portal.vm.custom.callCustomization('ShowAcademicTab', self);

        this.GetModelData = function (blockui, applicationMID, personMID, callback) {
            if (!this.DataLoaded() && !this.DataLoading()) {

                this.DataLoading(true);
                if (!sm.portal.utility.isNullOrEmpty(viewModel.allCustomData())) {
                    sm.portal.vm.custom.callCustomization('LoadCustomizedModel', self);
                    self.LoadModel(viewModel.allCustomData().Academic);
                    var customData = {
                        data: viewModel.allCustomData().Academic,
                        self: self
                    }
                    sm.portal.vm.custom.callCustomization('LoadDefaults', customData,
                        function () {
                            callback && callback(viewModel.allCustomData().Academic);
                        }
                    );
                    return;
                }
                if (blockui) {
                    jQuery.blockUI();
                }
                sm.portal.vm.custom.callCustomization('LoadCustomizedModel', self);

                var url =
                    _baseApiUri +
                    sm.portal.utility.formatString(
                        'api/studentportal/getapplicationsection?sectionName=academic&attemptmid={0}',
                        applicationMID
                    );

                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        'x-api-version': '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        sm.portal.page.application.modelDataResponseHandler(self, data, applicationMID, personMID);
                        var customData = {
                            data: data,
                            self: self
                        }
                        sm.portal.vm.custom.callCustomization('LoadDefaults', customData,
                            function () {
                                callback && callback(data);
                            }
                        );
                    },
                    error: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        callback && callback();
                    }
                });
            } else {
                callback && callback();
            }
        };
        this.BlockContainer = function () {
            jQuery('#' + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function () {
            jQuery('#' + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };
        this.ProcessOnServer = function () {
            return true;
        };
        this.ExtractATO = function () {
            // [EXTEND] New fields added to view model need to be updated here

            var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();

            var stdAdmissionsAttempt = new smapi.admissions.AdmissionsAttemptModel({
                PersonID: -1,
                AdmissionsAcademicLevelID: self.AcademicLevelID(),
                ExpectedStartPeriodID: self.ExpectedStartPeriodID(),
                EarliestStartDate: moment(self.EarliestStartDate(), dateFormat).format('YYYY-MM-DD'),
                ExpectedLoadID: self.ExpectedLoadID(),
                EnrollmentStatusID: self.InitialEnrollmentStatusID(),
                AttendanceTypeID: self.AttendanceTypeID(),
                AttendanceReasonID: self.AttendanceReasonID(),
                CampusID: self.CampusID(),
                DeliveryMethodID: self.DeliveryMethodID(),
                LevelOfStudyID: self.LevelOfStudyID()
            });
            // Admissions Programs
            var stdAdmProgram = new smapi.admissions.AdmissionsAttemptProgramModel({
                AdmissionsAcademicLevelID: self.AcademicLevelID(),
                ApplicationGoalID: self.ApplicationGoalID(),
                AdmissionProgramID: self.AdmissionsProgramID(),
                AdmissionsProgramOfferingItemID: self.AdmissionsProgramOfferingItemID()
            });

            var data = {
                stdAdmissionsAttempt: stdAdmissionsAttempt,
                stdAdmProgram: stdAdmProgram,
                self: self
            }

            var stdAdmissionsAttemptCustom = sm.portal.vm.custom.callCustomization('ExtractAdditionalATOForAcademicInterest', data);
            if (!sm.portal.utility.isNullOrEmpty(stdAdmissionsAttemptCustom)) {
                return stdAdmissionsAttemptCustom;
            }

            stdAdmissionsAttempt.AdmissionsAttemptPrograms.push(stdAdmProgram);

            return stdAdmissionsAttempt;
        };

        sm.portal.vm.custom.callCustomization('SubscribeAcademicLevelID', self);

        function ChooseDefaultLevelOfStudy(that) {
            SetLevelOfStudyOn();
            sm.portal.vm.custom.callCustomization('UpdatedChooseDefaultLevelOfStudy', self);

            if ((that.LevelOfStudyID() == undefined || sm.portal.utility.isNullOrEmpty(that.LevelOfStudyID())) && self.LevelOfStudyShow()) {
                var levelOfStudyArray;
                var data = {
                    levelOfStudyArray: levelOfStudyArray,
                    that: that,
                    self: self
                }

                sm.portal.vm.custom.callCustomization('UpdateLevelOfStudyArray', data,
                    function () {
                        levelOfStudyArray = that.LevelsOfStudy().sort(SortBySequence);
                    }
                );

                var defaultItem = levelOfStudyArray.filter(function (item) {
                    return item.IsDefault();
                });

                if (defaultItem.length >= 1) {
                    that.LevelOfStudyID(defaultItem[0].ID());
                } else {
                    if (levelOfStudyArray.length > 0) {
                        that.LevelOfStudyID(levelOfStudyArray[0].ID());
                    } else {
                        that.LevelOfStudyID(null);
                    }
                }
            }
        };

        function SetLevelOfStudyOn() {
            if (self.LevelOfStudyEnabled()) {
                if (self.LevelsOfStudy().length == 0) {
                    self.LevelOfStudyShow(false);
                    self.LevelOfStudyID(null);
                } else {
                    self.LevelOfStudyShow(true);
                }
            }
        };

        //To set Array Values as null if it is zero
        this.UnsetProp = function (props) {
            props.forEach(function (currentValue) {
                if (currentValue() == 0)
                    currentValue(null);
            });
        }

        //This will initialize the content of Academic Section
        this.Initialize = function () {

            var props = [this.ApplicationGoalID, this.AdmissionsProgramID];
            //GetAdmissionsOfferingMatrix API expect values as null for sending complete data of Academic Section.
            self.UnsetProp(props);

            this.getAvailableOptions(null, {
                successCallback: function (data) {
                    if (sm.portal.utility.isNullOrEmpty(sm.portal.vm.custom.callCustomization('SkipSetAvailableOptions'))) {
                        self.SetAvaliableOptions(data);
                    }
                    SetLevelOfStudyOn();
                },
                errorCallback: function (jqXHR, exception) {
                    sm.portal.page.application.modelErrorHandler(self, jqXHR);
                }
            });
        };

        this.ResetProgrammeCategoryID = function () {
            if (this.IsVMValid()) {
                return;
            }

            self.ProgrammeCategoryID(null);
        };

        //API call to get data for Academic Section
        this.getAvailableOptions = function (data, callback) {
            var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/GetAdmissionsOfferingMatrix');

            var optionsSelected = JSON.stringify(
                {
                    StartPeriodID: sm.portal.utility.isNullOrEmpty(this.ExpectedStartPeriodID()) ? null : this.ExpectedStartPeriodID(),
                    AcademicLevelID: sm.portal.utility.isNullOrEmpty(this.AcademicLevelID()) ? null : this.AcademicLevelID(),
                    ApplicationGoalID: sm.portal.utility.isNullOrEmpty(this.ApplicationGoalID()) ? null : this.ApplicationGoalID(),
                    AdmissionsProgramID: sm.portal.utility.isNullOrEmpty(this.AdmissionsProgramID()) ? null : this.AdmissionsProgramID(),
                    DeliveryMethodID: sm.portal.utility.isNullOrEmpty(this.DeliveryMethodID()) ? null : this.DeliveryMethodID(),
                    CampusID: sm.portal.utility.isNullOrEmpty(this.CampusID()) ? null : this.CampusID(),
                    AdmissionsOfferingItemID: sm.portal.utility.isNullOrEmpty(this.AdmissionsProgramOfferingItemID()) ? null : this.AdmissionsProgramOfferingItemID(),
                    LevelOfStudyID: sm.portal.utility.isNullOrEmpty(this.LevelOfStudyID()) ? null : this.LevelOfStudyID()

                });
            if (!this.DataLoading()) {
                self.BlockContainer();

                this.DataLoading(true);

                sm.portal.utility.AjaxPost(
                    url,
                    optionsSelected,
                    onSuccess = function (data, textStatus, jqXHR) {
                        callback && callback.successCallback && callback.successCallback(data, textStatus, jqXHR);                                              
                        //AdmissionsPrograms Selected Value
                        let admissionsProgramID = jQuery('select#AdmissionsProgramID option:selected').val();                        
                        if (!sm.portal.utility.isNullOrEmpty(admissionsProgramID) && admissionsProgramID != undefined) {
                            if (data.AdmissionsPrograms.length == 1) {
                                self.AdmissionsProgramDescription(data.AdmissionsPrograms[0].Description);
                                self.UpdateTemplateProperties.ShowAPDescriptionOnPortal(data.AdmissionsPrograms[0].ShowAPDescriptionOnPortal);
                            }
                            else {
                                self.AdmissionsProgramDescription('');
                                self.UpdateTemplateProperties.ShowAPDescriptionOnPortal(false);
                            }
                        }
                        //AdmissionsProgramOfferingItems Selected Value
                        let admissionsProgramOfferingItemID = jQuery('select#AdmissionsProgramOfferingItemID option:selected').val();                        
                        if (!sm.portal.utility.isNullOrEmpty(admissionsProgramOfferingItemID) && admissionsProgramOfferingItemID != undefined) {
                            if (data.AdmissionsProgramOfferingItems.length == 1) {
                                self.APOIDescription(data.AdmissionsProgramOfferingItems[0].APOIDescription);
                                self.UpdateTemplateProperties.ShowAPOIDescriptionOnPortal(data.AdmissionsProgramOfferingItems[0].ShowAPOIDescriptionOnPortal);
                            }
                            else {
                                self.APOIDescription('');
                                self.UpdateTemplateProperties.ShowAPOIDescriptionOnPortal(false);
                            }
                        }                        
                        self.UnBlockContainer();
                        self.DataLoading(false);
                    },
                    OnError = function (jqXHR, exception) {
                        callback && callback.errorCallback && callback.errorCallback(jqXHR, exception);
                        self.DataLoading(false);
                    },
                    complete = function (jqXHR, textStatus) {
                        callback && callback.completeCallback && callback.completeCallback(jqXHR, textStatus);
                    }
                );
            }
        };

        this.UpdateOptions = function (data, event) {
            var customData = {
                self: self,
                event: event
            }
            var latestAdmissionsProgramID = self.AdmissionsProgramID();
            var admissionsProgramOfferingItemsID = self.AdmissionsProgramOfferingItemID();
            var res = sm.portal.vm.custom.callCustomization('UpdateOptions', customData);
            if (sm.portal.utility.isNullOrEmpty(res)) {
                if (event.originalEvent) {
                    this.getAvailableOptions(null, {
                        successCallback: function (data) {
                            if (latestAdmissionsProgramID != null && latestAdmissionsProgramID != undefined) {
                                let selectedAPValue = data.AdmissionsPrograms.filter(v => v.ID == latestAdmissionsProgramID);
                                if (selectedAPValue.length > 0 && selectedAPValue[0].ShowAPDescriptionOnPortal) {
                                    self.AdmissionsProgramDescription(selectedAPValue[0].Description);
                                    self.UpdateTemplateProperties.ShowAPDescriptionOnPortal(selectedAPValue[0].ShowAPDescriptionOnPortal);
                                }
                                else {
                                    self.AdmissionsProgramDescription('');
                                    self.UpdateTemplateProperties.ShowAPDescriptionOnPortal(false);
                                }
                            }
                            else {
                                self.AdmissionsProgramDescription('');
                                self.UpdateTemplateProperties.ShowAPDescriptionOnPortal(false);
                            }

                            if (admissionsProgramOfferingItemsID != null && admissionsProgramOfferingItemsID != undefined) {
                                let admissionsProgramOfferingItems = data.AdmissionsProgramOfferingItems.filter(v => v.ID == admissionsProgramOfferingItemsID);
                                if (admissionsProgramOfferingItems.length > 0 && admissionsProgramOfferingItems[0].ShowAPOIDescriptionOnPortal) {
                                    self.APOIDescription(admissionsProgramOfferingItems[0].APOIDescription);
                                    self.UpdateTemplateProperties.ShowAPOIDescriptionOnPortal(true);
                                }
                                else {
                                    self.APOIDescription('');
                                    self.UpdateTemplateProperties.ShowAPOIDescriptionOnPortal(false);
                                }

                            }
                            else {
                                self.APOIDescription('');
                                self.UpdateTemplateProperties.ShowAPOIDescriptionOnPortal(false);
                            }

                            var id = (event && event.target && event.target.id) || null;
                            self.SetAvaliableOptions(data, id);
                        },
                        errorCallback: function (jqXHR, exception) {
                            sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        },
                        completeCallback: function (jqXHR, textStatus) {
                            event && event.target && event.target.focus();
                        },
                    });
                }
            }
        };

        this.RunAutoSelect = function (options) {

            if (this.AutoSelectOptions(options)) {

                this.DataLoading(false);
                this.getAvailableOptions(null, {
                    successCallback: function (data) {
                        self.RunAutoSelect(data);
                    },
                    errorCallback: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                    }
                });
            }
        }

        this.AutoSelectOptions = function (options) {

            var atLeastOneDropdownWasAutoSelected = false;

            if (options.ExpectedStartPeriods.length === 0) { this.ExpectedStartPeriodID(null) }
            if (options.ExpectedStartPeriods.length === 1
                && (sm.portal.utility.isNullOrEmpty(this.ExpectedStartPeriodID()) || this.ExpectedStartPeriodID() != options.ExpectedStartPeriods[0].ID)) {
                self.AcademicPeriods(smapi.access.loadListItemModels(options.ExpectedStartPeriods, [], true));
                self.ExpectedStartPeriodID(options.ExpectedStartPeriods[0].ID);
                atLeastOneDropdownWasAutoSelected = true;
            }
            if (options.AcademicLevels.length === 0) { this.AcademicLevelID(null) }
            if (options.AcademicLevels.length === 1
                && (sm.portal.utility.isNullOrEmpty(this.AcademicLevelID()) || this.AcademicLevelID() != options.AcademicLevels[0].ID)) {
                self.AdmissionsAcademicLevels(smapi.access.loadListItemModels(options.AcademicLevels, [], true));
                self.AcademicLevelID(options.AcademicLevels[0].ID);
                atLeastOneDropdownWasAutoSelected = true;
            }
            if (options.ApplicationGoals.length === 0) { this.ApplicationGoalID(null) }
            if (options.ApplicationGoals.length === 1
                && (sm.portal.utility.isNullOrEmpty(this.ApplicationGoalID()) || this.ApplicationGoalID() != options.ApplicationGoals[0].ID)) {
                self.Goals(smapi.access.loadListItemModels(options.ApplicationGoals, [], true));
                self.ApplicationGoalID(options.ApplicationGoals[0].ID);
                atLeastOneDropdownWasAutoSelected = true;
            }
            if (options.AdmissionsPrograms.length === 0) { this.AdmissionsProgramID(null) }
            if (options.AdmissionsPrograms.length === 1
                && (sm.portal.utility.isNullOrEmpty(this.AdmissionsProgramID()) || this.AdmissionsProgramID() != options.AdmissionsPrograms[0].ID)) {
                self.AdmissionsPrograms(smapi.access.loadListItemModels(options.AdmissionsPrograms, [], true));
                self.AdmissionsProgramID(options.AdmissionsPrograms[0].ID);
                atLeastOneDropdownWasAutoSelected = true;
            }
            if (options.DeliveryMethods.length === 0) { this.DeliveryMethodID(null) }
            if (options.DeliveryMethods.length === 1
                && (sm.portal.utility.isNullOrEmpty(this.DeliveryMethodID()) || this.DeliveryMethodID() != options.DeliveryMethods[0].ID)) {
                self.DeliveryMethods(smapi.access.loadListItemModels(options.DeliveryMethods, [], true));
                self.DeliveryMethodID(options.DeliveryMethods[0].ID);
                atLeastOneDropdownWasAutoSelected = true;
            }
            if (options.AdmissionsProgramOfferingItems.length === 0) { this.AdmissionsProgramOfferingItemID(null) }
            if (options.AdmissionsProgramOfferingItems.length === 1
                && (sm.portal.utility.isNullOrEmpty(this.AdmissionsProgramOfferingItemID()) || this.AdmissionsProgramOfferingItemID() != options.AdmissionsProgramOfferingItems[0].ID)) {
                self.AdmissionsOfferingItems(smapi.access.loadListItemModels(options.AdmissionsProgramOfferingItems, [], true));
                self.AdmissionsProgramOfferingItemID(options.AdmissionsProgramOfferingItems[0].ID);
                atLeastOneDropdownWasAutoSelected = true;
            }
            if (options.Campuses.length === 0) { this.CampusID(null) }
            if (options.Campuses.length === 1
                && (sm.portal.utility.isNullOrEmpty(this.CampusID()) || this.CampusID() != options.Campuses[0].ID)) {
                self.Campuses(smapi.access.loadListItemModels(options.Campuses, [], true));
                self.CampusID(options.Campuses[0].ID);
                atLeastOneDropdownWasAutoSelected = true;
            }
            return atLeastOneDropdownWasAutoSelected;
        }

        this.SetAvaliableOptions = function (options, id) {

            self.AcademicPeriods(smapi.access.loadListItemModels(options.ExpectedStartPeriods, [], true));
            self.AdmissionsAcademicLevels(smapi.access.loadListItemModels(options.AcademicLevels, [], true));
            self.Goals(smapi.access.loadListItemModels(options.ApplicationGoals, [], true));
            self.AdmissionsPrograms(smapi.access.loadListItemModels(options.AdmissionsPrograms, [], true));
            self.DeliveryMethods(smapi.access.loadListItemModels(options.DeliveryMethods, [], true));
            self.AdmissionsOfferingItems(smapi.access.loadListItemModels(options.AdmissionsProgramOfferingItems, [], true));
            self.Campuses(smapi.access.loadListItemModels(options.Campuses, [], true));

            self.UpdateTemplateProperties.AcademicStartPeriodVisible(!self.UpdateTemplateProperties.AcademicStartPeriodRequired() ? self.UpdateTemplateProperties.AcademicStartPeriodVisible() : (self.UpdateTemplateProperties.AcademicStartPeriodVisible() ? true : (options.ExpectedStartPeriods.length > 1 ? true : !this.UpdateTemplateProperties.AutoSelectSingleFields())));
            self.UpdateTemplateProperties.AcademicLevelVisible(!self.UpdateTemplateProperties.AcademicLevelRequired() ? self.UpdateTemplateProperties.AcademicLevelVisible() : (self.UpdateTemplateProperties.AcademicLevelVisible() ? true : (options.AcademicLevels.length > 1 ? true : !this.UpdateTemplateProperties.AutoSelectSingleFields())));
            self.UpdateTemplateProperties.ApplicationGoalVisible(!self.UpdateTemplateProperties.ApplicationGoalRequired() ? self.UpdateTemplateProperties.ApplicationGoalVisible() : (self.UpdateTemplateProperties.ApplicationGoalVisible() ? true : (options.ApplicationGoals.length > 1 ? true : !this.UpdateTemplateProperties.AutoSelectSingleFields())));
            self.UpdateTemplateProperties.AdmissionsProgramVisible(!self.UpdateTemplateProperties.AdmissionsProgramRequired() ? self.UpdateTemplateProperties.AdmissionsProgramVisible() : (self.UpdateTemplateProperties.AdmissionsProgramVisible() ? true : (options.AdmissionsPrograms.length > 1 ? true : !this.UpdateTemplateProperties.AutoSelectSingleFields())));
            self.UpdateTemplateProperties.DeliveryMethodVisible(!self.UpdateTemplateProperties.DeliveryMethodRequired() ? self.UpdateTemplateProperties.DeliveryMethodVisible() : (self.UpdateTemplateProperties.DeliveryMethodVisible() ? true : (options.DeliveryMethods.length > 1 ? true : !this.UpdateTemplateProperties.AutoSelectSingleFields())));
            self.UpdateTemplateProperties.ProgramRouteVisible(!self.UpdateTemplateProperties.ProgramRouteRequired() ? self.UpdateTemplateProperties.ProgramRouteVisible() : (self.UpdateTemplateProperties.ProgramRouteVisible() ? true : (options.AdmissionsProgramOfferingItems.length > 1 ? true : !this.UpdateTemplateProperties.AutoSelectSingleFields())));
            self.UpdateTemplateProperties.CampusVisible(!self.UpdateTemplateProperties.CampusRequired() ? self.UpdateTemplateProperties.CampusVisible() : (self.UpdateTemplateProperties.CampusVisible() ? true : (options.Campuses.length > 1 ? true : !this.UpdateTemplateProperties.AutoSelectSingleFields())));

            self.LevelsOfStudy(smapi.access.loadListItemModels(options.LevelsOfStudy.sort(function (l, r) { return l.Sequence - r.Sequence; }), []));

            if (id === 'AcademicLevelID') {
                if (!!self.LevelOfStudyID() && !!options.LevelsOfStudy.find(function (element) { return element.ID == self.LevelOfStudyID(); })) {
                    return;
                }

                var defaultLevelOfStudy = self.LevelOfStudiesOn() && self.AcademicDetails().AcademicLevelID()
                    ? options.LevelsOfStudy.find(function (element) { return element.IsDefault; })
                    : undefined;
                self.LevelOfStudyID(!!defaultLevelOfStudy ? defaultLevelOfStudy.ID : undefined);
            }

            if (self.UpdateTemplateProperties.AutoSelectSingleFields()) { this.RunAutoSelect(options); }
        };

        this.ResetDropdowns = function () {
            self.ExpectedStartPeriodID(null);
            self.ExpectedStartPeriodID.isModified(false);

            self.AcademicLevelID(null);
            self.AcademicLevelID.isModified(false);

            self.ApplicationGoalID(null);
            self.ApplicationGoalID.isModified(false);

            self.AdmissionsProgramID(null);
            self.AdmissionsProgramID.isModified(false);

            self.DeliveryMethodID(null);
            self.DeliveryMethodID.isModified(false);

            self.AdmissionsProgramOfferingItemID(null);
            self.AdmissionsProgramOfferingItemID.isModified(false);

            self.CampusID(null);
            self.CampusID.isModified(false);

            /*
            self.InitialEnrollmentStatusID(null);
            self.InitialEnrollmentStatusID.isModified(false);
    
            self.ExpectedLoadID(null);
            self.ExpectedLoadID.isModified(false);
    
            self.AttendanceTypeID(null);
            self.AttendanceTypeID.isModified(false);
    
            self.AttendanceReasonID(null);
            self.AttendanceReasonID.isModified(false);
            */

            self.EarliestStartDate(null);
            self.EarliestStartDate.isModified(false);

            self.CategoryID(null);
            self.CategoryID.isModified(false);

            self.LevelOfStudyID(null);
            self.LevelOfStudyID.isModified(false);

            this.Initialize();
        };
        /*** SECTION METHODS ***/

        /*** VALIDATION METHODS ***/

        sm.portal.vm.custom.callCustomization('OverrideAcademicValidation', self);

        this.ExpectedStartPeriodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            required: {
                onlyIf: function () {
                    return self.ExpectedEntrancePeriodRequired() || self.UpdateTemplateProperties.AcademicStartPeriodRequired();
                },
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.DeliveryMethodID.extend({
            required: {
                onlyIf: function () {
                    return self.UpdateTemplateProperties.DeliveryMethodRequired();
                },
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsProgramOfferingItemID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            required: {
                onlyIf: function () {
                    return self.AdmissionsProgramOfferingItemEnabled() || self.UpdateTemplateProperties.ProgramRouteRequired();
                },
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.CampusID.extend({
            required: {
                onlyIf: function () {
                    return self.UpdateTemplateProperties.CampusRequired();
                },
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ApplicationGoalID.extend({
            required: {
                onlyIf: function () {
                    return self.UpdateTemplateProperties.ApplicationGoalRequired();
                },
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsProgramID.extend({
            required: {
                onlyIf: function () {
                    return self.UpdateTemplateProperties.AdmissionsProgramRequired();
                },
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicLevelID.extend({
            required: {
                onlyIf: function () {
                    return self.UpdateTemplateProperties.AcademicLevelRequired();
                },
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EarliestStartDate.extend({
            smLocalDate: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.CategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InitialEnrollmentStatusID.extend({
            required: {
                onlyIf: function () {
                    return self.UpdateTemplateProperties.InitialEnrollmentRequired();
                },
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExpectedLoadID.extend({
            required: {
                onlyIf: function () {
                    return self.UpdateTemplateProperties.ExpectedEnrollmentRequired();
                },
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AttendanceTypeID.extend({
            required: {
                onlyIf: function () {
                    return self.UpdateTemplateProperties.AttendanceTypeRequired();
                },
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AttendanceReasonID.extend({
            required: {
                onlyIf: function () {
                    return self.UpdateTemplateProperties.AttendanceReasonRequired();
                },
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.LevelOfStudyID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            required: {
                onlyIf: function () {
                    return self.LevelOfStudiesOn();
                },
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            var isCompleted = this.IsVMValid();
            return isCompleted;
        }, this);
        /*** VALIDATION METHODS ***/

        this.ValidateModel = function () {
            self.validationEnabled(true);
            if (!this.IsVMValid()) {
                return false;
            } else {
                return true;
            }
        };

        return self;
    }

    if (typeof sm.portal.vm.AcademicInterestsViewModel === 'undefined') {
        jQuery.extend(true, sm.portal.vm, {
            AcademicInterestsViewModel: AcademicInterestsViewModel
        });
    }
})(jQuery);
